import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AddEvent, EditEvent, SaveEvent, GridComponent } from '@progress/kendo-angular-grid';
import { CancelEvent, RemoveEvent } from '@progress/kendo-angular-upload';
import { FixedCutterBrazedIn } from '../../../interfaces/request.interface';

@Component({
    selector: 'app-brazeinports-data',
    templateUrl: './brazeinports-data.component.html',
    styleUrl: './brazeinports-data.component.css',
    standalone: false
})
export class BrazeinportsDataComponent {
  
};
